import markSrc from '../assets/images/logo_no_back_512.png';

/**
 * The ShareShutter mark set with the wordmark beside it, mirroring
 * common/lib/widgets/brand_lockup.dart. The mark carries no lettering of its
 * own, so the name always comes from type.
 */
export default function BrandLockup({ size = 30, className = '' }) {
  return (
    <span className={`brand ${className}`.trim()} style={{ '--mark-size': `${size}px` }}>
      <img className="brand__mark" src={markSrc} alt="" width={size} height={size} />
      <span className="brand__wordmark">ShareShutter</span>
    </span>
  );
}
